import { render, staticRenderFns } from "./refundUserExpress.vue?vue&type=template&id=3b37aa39&scoped=true"
import script from "./refundUserExpress.vue?vue&type=script&lang=js"
export * from "./refundUserExpress.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b37aa39",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/chillzon/Documents/projects/crmeb_view/mer_plat_admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3b37aa39')) {
      api.createRecord('3b37aa39', component.options)
    } else {
      api.reload('3b37aa39', component.options)
    }
    module.hot.accept("./refundUserExpress.vue?vue&type=template&id=3b37aa39&scoped=true", function () {
      api.rerender('3b37aa39', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/marketing/pointsMall/components/refundUserExpress.vue"
export default component.exports